// require('three/examples/js/shaders/CopyShader');
// require('three/examples/js/shaders/FXAAShader');
// require('three/examples/js/shaders/SSAOShader');
// require('three/examples/js/postprocessing/EffectComposer');
// require('three/examples/js/postprocessing/RenderPass');
// require('three/examples/js/postprocessing/ShaderPass');
// require("three/examples/js/loaders/collada/AnimationHandler");
// require("three/examples/js/loaders/collada/KeyFrameAnimation");
// require("three/examples/js/renderers/SoftwareRenderer");

import * as base from "./base";
import * as webcad from "./webcad";
export{
    base,
    webcad
}
